<template>
  <div class="talent-wrap ">
    <div class="talent-body-wrap home-mini-width hom-max-width">
      <TitleCard
        title="产业导航"
        :loading="loading1"
        :isEmpty="isEmpty1"
        :type="'firstCard'"
        @moreClick="toRouter('IndustryNavigationList')"
      >
        <div class="searchCard">
          <TableCard
            :tableList="resultList"
            @moreChange="toDetails"
          ></TableCard>
        </div>
      </TitleCard>
      <TitleCard
        title="专利信息分析"
        :loading="loading"
        :isEmpty="isEmpty"
        :type="'firstCard'"
        @moreClick="showQrcode"
      >
        <div class="searchCard">
          <TableCard
            :tableList="dataList"
            @moreChange="patentToDetails"
          ></TableCard>
        </div>
      </TitleCard>
    </div>
    <a-modal
      :title="title"
      :visible="visible"
      width="1000px"
      :footer="null"
      @cancel="handleCancel"
    >
      <div>
        <iframe
          :src="pdfUrl"
          width="100%"
          height="600px"
          class="iframeBox"
        ></iframe>
      </div>
    </a-modal>
    <CodeModel v-if="isShowCode" @cancel="codeCancel"></CodeModel>
  </div>
</template>

<script>
import TableCard from '@/components/common/tableCard'
import { infoList } from '@/api/technicalR'
import { Mixin } from './pages/mixins'
import { getIndustryInfo } from '@/api/IpProject'
import { picList } from './configs/config'
import CodeModel from './pages/components/codeModel'
import { productDataBase } from '@/api/competitor';

export default {
  data() {
    return {
      loading: false,
      isEmpty: false,
      loading1: false,
      isEmpty1: false,
      resultList: [],
      searchParams: {
        industry: '',
        expertsType: '',
        pageSize: 10,
        pageNum: 1
      },
      infoParams: {
        pageSize: 3,
        pageNum: 1,
        status: 1
      },
      dataList: [],
      isShowCode: false
    }
  },
  mixins: [Mixin],
  components: {
    TableCard,
    CodeModel
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      // 产业导航
      this.loading1 = true
      this.loading = true
      let data = await infoList(this.infoParams)
      const info = await productDataBase()
      if(process.env.VUE_APP_KEY === 'SzTech') { // 深圳市新材料产业知识产权运营公共服务平台  特殊处理
        data.rows = data.rows.reduce((newList, item) => {
          if(item.title !== '高端装备制造' && item.title !== '新能源产业') {
            const { access_token } = info.data;
            const { refresh_token } = info.data;
            item.outLink = `http://5q16p85626.zicp.vip:10000/token?token=${access_token}&refresh_token=${refresh_token}`
            newList.push(item)
          }
          return newList
        }, [])
      }
      this.loading1 = false
      this.isEmpty1 = data.rows.length === 0
      this.resultList = data.rows
      this.resultList.forEach(item => {
        item.img = this.getUrl(item)
      })
      let id = process.env.VUE_APP_OFFICE_ID
      const pSize = process.env.VUE_APP_KEY === 'SzTech' ? 4 : 3
      let params = {
        pageNum: 1,
        pageSize: pSize,
        id: id
      }
      let res = await getIndustryInfo(params)
      this.loading = false
      this.isEmpty = res.total === 0
      this.dataList = res.data.reduce((pre, item, index) => {
        item = {
          ...item,
          img: picList[index]
        }
        pre.push(item)
        return pre
      }, [])
    },
    showQrcode() {
      this.isShowCode = true
    },
    getUrl(item) {
      if (item.fileVo !== null && item.fileVo.length > 0) {
        return item.fileVo[0].filePath
      } else {
        return ''
      }
    },
    codeCancel() {
      this.isShowCode = false
    },
    toRouter(router, params) {
      this.$router.push({ name: router, query: { ...params } })
    },
    // 跳转详情
    toDetail(uid) {
      this.$router.push({ name: 'talentDetail', query: { uid } })
    },
    patentToDetails(item) {
      this.$router.push({
        path: `/IndustryInformation/List?id=${item.id}&name=${item.name}`
      })
    }
  }
}
</script>
<style scoped>
.infos-wrap {
  display: inline-block;
}
</style>
